import { Link } from "react-router-dom";
import { MessageCircle, ArrowLeft } from "lucide-react";
import { usePageMeta } from "../lib/pageMeta";

const WHATSAPP_URL = "https://wa.me/447474759947";

export default function LongStayThankYou() {
  usePageMeta({
    title: "Thank you — West London Stays",
    description: "Enquiry received. We'll reply within a few hours.",
    noindex: true,
  });

  return (
    <div data-testid="long-stay-thankyou" className="bg-[#050505] text-white min-h-[60vh] flex items-center pt-28 pb-24 -mb-24">
      <div className="container mx-auto px-6 md:px-12 max-w-2xl text-center">
        <p className="overline mb-5">Received</p>
        <h1 className="font-serif text-4xl sm:text-5xl leading-tight text-white mb-5" data-testid="thankyou-title">
          Thank you — your enquiry is in.
        </h1>
        <p className="text-white/65 leading-relaxed mb-10">
          I'll reply within a few hours. If it's urgent, message me on WhatsApp.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-3">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="thankyou-whatsapp"
            className="btn-emerald justify-center"
          >
            <MessageCircle size={14} /> Message the host
          </a>
          <Link to="/" data-testid="thankyou-home" className="btn-outline-gold justify-center">
            <ArrowLeft size={14} /> Back to West London Stays
          </Link>
        </div>
      </div>
    </div>
  );
}
